import { type MenuProps } from "antd";

export const timePicker: Record<string, number> = {
  // время в секундах
  "1": 60 * 60,
  "2": 2 * 60 * 60,
  "3": 3 * 60 * 60,
  "4": 24 * 60 * 60,
  "5": 2 * 24 * 60 * 60,
  "6": 3 * 24 * 60 * 60,
};

// items для DropDownMenu
export const items: MenuProps["items"] = [
  {
    label: "1 час",
    key: "1",
  },
  {
    label: "2 часа",
    key: "2",
  },
  {
    label: "3 часа",
    key: "3",
  },
  {
    label: "1 день",
    key: "4",
  },
  {
    label: "2 дня",
    key: "5",
  },
  {
    label: "3 дня",
    key: "6",
  },
];
